<template>
	<div
		:class="`formulate-input-element formulate-input-element--${context.class}`"
		:data-type="context.type"
	>
		<b-form-checkbox
			:checked="context.model"
			name="check-button"
			switch
			:value="true"
			:unchecked-value="false"
			@change="handleChange"
		>
			{{ context.attributes['label-text'] }}
		</b-form-checkbox>
	</div>
</template>
<script>

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	mounted() {
		if (!this.context.model) this.context.rootEmit('input', false);
	},
	methods: {
		handleChange(event) {
			this.context.rootEmit('input', event);
		},
	},
};
</script>
<style lang="scss">
.custom-switch {
    padding-left: 1.3rem;

	.custom-control-label {
		line-height: 1.2 !important;
	}
}
</style>
